import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlinePlus } from 'react-icons/hi2';
import { useRiders } from '../../hooks/useRiders';
import Skeleton from '../../components/Skeleton';
import SectionHeader from '../../components/SectionHeader';
import { createColumnHelper } from '@tanstack/react-table';
import Table from '../../components/Table';
import Button from '../../components/Button';
import ButtonList from '../../components/ButtonList';
import { getDisplayName, Rider } from 'types/Rider';

export default function RiderList(): ReactElement {
  const { isPending: isRidersPending, isFetching: isRidersFetching, data: ridersData } = useRiders();
  const navigate = useNavigate();

  const columnHelper = createColumnHelper<Rider>();
  const tableColumns = [
    columnHelper.accessor('first_name', {
      header: 'First Name',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('last_name', {
      header: 'Last Name',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('nickname', {
      header: 'Nickname',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => getDisplayName(row), {
      header: 'Display Name',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('mass', {
      header: 'Mass',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('time_ref_minutes', {
      header: 'Time Ref (min)',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('distance_ref_km', {
      header: 'Dist Ref (km)',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('speed_ref_kmh', {
      header: 'Speed Ref (km/h)',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
    columnHelper.accessor('power_ref', {
      header: 'Power Ref',
      cell: (info) => info.getValue() || '-',
      enableSorting: true,
    }),
  ];

  return (
    <div className="cr-w-full">
      <SectionHeader title="Riders" isLoading={isRidersFetching} />
      <div className="cr-mb-4">
        <ButtonList>
          <Button onClick={() => navigate('/riders/new')} icon={<HiOutlinePlus className="cr-size-7" />}>
            New Rider
          </Button>
        </ButtonList>
      </div>
      <Skeleton isPending={isRidersPending}>
        <Table
          data={ridersData || []}
          columns={tableColumns}
          isLoading={isRidersPending}
          onRowClick={(e, row) => navigate(`/riders/${row.id}`)}
        />
      </Skeleton>
    </div>
  );
}
